/** Sent on web guest vote API calls so backend applies IP daily limit. */
export const GUEST_VOTE_WEB_HEADERS = {
  "X-Client-Platform": "web",
};

export function guestVoteLimitHit(payload) {
  return Boolean(payload?.requiresRegistration);
}

export function guestVotingDisabled(payload) {
  return Boolean(payload?.guestVotingDisabled);
}

export function handleGuestVoteFailure(
  payload,
  { onLimit, onDisabled } = {}
) {
  if (guestVotingDisabled(payload)) {
    onDisabled?.(payload?.message);
    return true;
  }
  if (guestVoteLimitHit(payload)) {
    onLimit?.();
    return true;
  }
  return false;
}

export const GUEST_VOTE_LIMIT_MESSAGE =
  "You have already voted on this video today. Please register to continue voting.";

export const GUEST_FINAL_NIGHT_VOTE_LIMIT_MESSAGE =
  "You have already used your free vote for this round. Please register to continue voting.";

export const GUEST_COMPETITION_VOTE_LIMIT_MESSAGE =
  "You have used your free guest vote for today in this competition. Please register to continue voting.";

export const GUEST_FOOTBALL_DISABLED_MESSAGE =
  "Guest voting for football is currently disabled. Please register or log in to vote.";

export const GUEST_PAGEANT_DISABLED_MESSAGE =
  "Guest voting for pageant competitions is currently disabled. Please register or log in to vote.";
